import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomProperties } from '@innovation-os-ng/core/core';
import { Ui2TagModule } from '@innovation-os-ng/ui/ui2-tag';
import { TitleCasePipe } from '@innovation-os-ng/ui/utils';
import { TranslateModule } from '@itonics/ngx-translate-simple';
import { DEFAULT_CASE_LANGUAGE } from '../../../facts/constants/constants';
import { TrackedEvents } from '../../constants/tracked-events';
import { FactSummary, Topic } from '../../interfaces/feed';

@Component({
  selector: 'signals-tag-cloud',
  templateUrl: './tag-cloud.component.html',
  styleUrls: ['./tag-cloud.component.scss'],
  standalone: true,
  imports: [CommonModule, Ui2TagModule, TitleCasePipe, TranslateModule]
})
export class TagCloudComponent<T extends FactSummary | Topic> implements OnInit {
  // Tags to show (each item must have a 'label' property)
  @Input()
  public items: Array<T> = [];

  // 'Type' of the tags (only used for tracking)
  @Input()
  public type: string;

  // How many tags to show before the accordion is expanded
  @Input()
  public initialNumTagsToShow: number;

  // If false, tags will be displayed as readonly
  @Input()
  public isClickable: boolean;

  // Tooltip to show over a clickable tag
  @Input()
  public tooltip: string;

  // Emits the item that was clicked
  @Output()
  public clicked = new EventEmitter<T>();

  //  Emit event name for tracking via ancestor / hosting app
  @Output()
  public trackEventViaAncestor = new EventEmitter<[string, CustomProperties?]>();

  // True when the accordion is expanded
  public showOverflow: boolean;

  // Expose constants
  public DEFAULT_CASE_LANGUAGE = DEFAULT_CASE_LANGUAGE;

  // If no initialNumTagsToShow is given, show all tags by default
  ngOnInit(): void {
    this.showOverflow = !this.initialNumTagsToShow;
  }

  /**
   * Show all items (note: there is currently no way to shrink this once its expanded)
   */
  public expandAccordion() {
    this.trackEventViaAncestor.emit([TrackedEvents.EXPAND_TAGS, { dimension4: this.type }]);
    this.showOverflow = true;
  }

  /**
   * we have used this function to prevent click event propagation
   * since ui2-tag doesn't return and click event,
   *
   * @param event
   */
  public preventClickPropagation(event: MouseEvent): void {
    if (this.isClickable) {
      event.stopPropagation();
    }
  }
}
